import React from 'react'
import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

function AuthorLink() {
  return (
    <Button
      size="tiny"
      type="ghost"
      color="white-100"
      href="/zippylee"
      customClass="bg-author"
    >
      Created by ZippyLee
    </Button>
  )
}

export default AuthorLink
